import React from "react";
import env from "../../../env";
import { usePost } from "../../../components";
import { useForm } from "../../../form";
import { Button, ErrorMessage, useRecaptchaCheckbox } from "../../../components";
import { getContactModel } from "./contactFormModel";
import { gtm } from "../../../lib/tracking";

export function Contact(props) {
  const emailReceiver = props.emailReceiver;
  const fileAttachment = props.fileAttachment || "false";
  const mailchimpApiKey = props.mailchimpApiKey;
  const mailchimpAudienceKey = props.mailchimpAudienceKey;

  const model = getContactModel({});
  const form = useForm(model, { usePlaceholder: true });
  const [sendingStatus, setSendingStatus] = React.useState(null);
  const [mailChimpError, setMailChimpError] = React.useState();
  const post = usePost();
  const recaptchaCheckbox = useRecaptchaCheckbox();
  const [recaptchaError, setRecaptchaError] = React.useState(null);

  const mailChimpErrorMemo = React.useMemo(() => {
    return mailChimpError;
  }, [mailChimpError]);

  function onSubmit(e) {
    setMailChimpError(null);
    setRecaptchaError(null);
    form.validateForm(e, () => {
      if (recaptchaCheckbox.enabled && !recaptchaCheckbox.token) {
        setRecaptchaError("Please tick the \"I'm not a robot\" checkbox.");
        return;
      }
      const recaptchaV2Token = recaptchaCheckbox.token;
      window.grecaptcha.ready(function () {
        window.grecaptcha
          .execute(env.reCaptchaSiteKey, { action: "submit" })
          .then(function (token) {
            const value = {
              ...form.getValue(),
              emailReceiver: emailReceiver,
              mailchimpApiKey: mailchimpApiKey,
              mailchimpAudienceKey: mailchimpAudienceKey,
              grecaptchaToken: token,
              grecaptchaV2Token: recaptchaV2Token,
            };

            var files = form.getFiles();
            var formData = new FormData();
            formData.append("jsonData", JSON.stringify(value));
            files.forEach((file) => {
              (file.files || []).forEach((uploadFile) => {
                formData.append(file.name, uploadFile);
              });
            });
            post.sendFormData(env.apiBase + "/api/contact/send", formData);
            setSendingStatus("pending");
            // v2 tokens are single use - reset the checkbox after each submit
            recaptchaCheckbox.reset();
          });
      });
    });
  }

  if (post.done() && sendingStatus === "pending") {
    var value = form.getValue();
    gtm.sendEvent("contactFormSubmitted", { contactEmail: value.email });
    form.reset(model);
    setSendingStatus(null);

    if (
      post.response.results &&
      post.response.results.MailChimpError &&
      post.response.results.MailChimpError !== ""
    ) {
      setMailChimpError(
        "Mail Chimp Error : " + post.response.results.MailChimpError
      );
    }
  }

  const render = (name) => form.renderControl(name, null);

  return (
    <form className='contactForm'>
      <div className='form-row'>
        <div className='col-md-4 mb-2'>{render("name")}</div>
        <div className='col-md-4 mb-2'>{render("phone")}</div>
        <div className='col-md-4 mb-2'>{render("email")}</div>
      </div>

      <div className='form-row'>
        <div className='col-md-12 mb-2'>{render("enquiry")}</div>
      </div>

      {fileAttachment === "true" && (
        <div className='form-row'>
          <div className='col-md-12 mb-2'> {render("attachments")} </div>
        </div>
      )}

      {recaptchaCheckbox.enabled && (
        <div className='form-row'>
          <div className='col-md-12 mb-2'>{recaptchaCheckbox.element}</div>
        </div>
      )}

      <div className='form-row'>
        <div className='col-md-12 mb-2'>
          <div className='actions'>
            <Button onClick={onSubmit} status={post.status}>
              Send Message
            </Button>
            <ErrorMessage
              errors={form.errors}
              summaryMessage='Please review the errors.'
            />
            <ErrorMessage errors={recaptchaError} />
            <ErrorMessage errors={post.errors} />
            <ErrorMessage errors={mailChimpErrorMemo} />
            {post.done() && (
              <span
                style={{
                  marginLeft: "1.5rem",
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                Successfully sent!
              </span>
            )}
          </div>
        </div>
      </div>
    </form>
  );
}
